import { render } from "./TextFileLoadBackupPopup.vue?vue&type=template&id=71f86419&scoped=true"
import script from "./TextFileLoadBackupPopup.vue?vue&type=script&lang=js"
export * from "./TextFileLoadBackupPopup.vue?vue&type=script&lang=js"

import "./TextFileLoadBackupPopup.vue?vue&type=style&index=0&id=71f86419&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f86419"]])

export default __exports__